import React, { memo, useState, useEffect } from "react";
import { useStore } from "src/store";

import { Icon } from "src/primitives";
import { replaceUrlParam, getQs } from "src/utils";

import Menu from "./Menu";
import styles from "./style.css";

const HomeFeaturedAdTiles = memo(props => {
  const { tiles = {}, brand } = props;
  const { value = [] } = tiles;

  return value
    .sort((a, b) => b.slot - a.slot)
    .map(tile => {
      let redirectURL = tile.url;
      redirectURL = replaceUrlParam(redirectURL, "brand", brand);
      redirectURL = replaceUrlParam(redirectURL, "placement", tile.placement);

      const clickUrl = `${window.GLOBALS.API.AD_REQUESTS}${getQs({
        clientid: tiles.clientid,
        type: "click",
        adCampaign: `featuredHomeHeaderAdTilesVer2-${encodeURIComponent(tile.title)}`,
        provider: "AirFind",
        redirectURL: encodeURIComponent(redirectURL)
      })}`;

      return (
        <li key={tile.img}>
          <a href={clickUrl} target={tile.openLinkInExistingTab ? "_self" : "_blank"} rel="noreferrer">
            <img src={tile.img} />
          </a>
        </li>
      );
    });
});

const AccountServicesBtn = memo(props => {
  const { img } = props;

  return (
    <li>
      <a href="//home.tracfone.com/account-services">
        <img src={img || `${window.GLOBALS.ASSETS.CORE}/img/sign-in-btn.png`} />
      </a>
    </li>
  );
});

const NavComponent = memo(props => {
  const { navControls = {}, navStyle, navComponentBgLogo, navComponentIconLogo, extraIconDestinationUrl = "" } = props;
  const [rightSideIcons, setRightSideIcons] = useState([]);

  const {
    logoFile,
    homeFeaturedAdTiles = false,
    logoPosition,
    hamburgerPosition,
    value = [],
    backgroundColor,
    backgroundImageFile,
    extraIconImageFile,
    dropdownTextColor,
    btnBackgroundImageFile
  } = navControls;

  let bgImage = navComponentBgLogo || backgroundImageFile;
  let extraIconImg = navComponentIconLogo || extraIconImageFile;

  useEffect(() => {
    if (bgImage) {
      addBackgroundImage();
    }
  }, [bgImage]);

  const addBackgroundImage = () => {
    const navComponent = document.querySelector('[data-af-component="NavComponent"]');
    if (navComponent) {
      navComponent.style.backgroundImage = "url(" + bgImage + ")";
      navComponent.style.backgroundSize = 'cover';
    }
  };

  const store = useStore("config");
  const { brand } = store("config");

  const [showMenu, setShowMenu] = useState(false);

  const showMenuLink = value.length > 0;
  const containerHeight = navStyle == "v1.5" ? "60%" : "80%";

  if (logoPosition === "rightAligned") {
    if (!rightSideIcons.some(el => el.type === "header")) {
      rightSideIcons.push(
        <header style={{ height: containerHeight }} className={styles.header}>
          <img src={logoFile} />
        </header>
      );
      setRightSideIcons(rightSideIcons);
    }
  }

  if (hamburgerPosition === "rightAligned" && showMenuLink) {
    if (!rightSideIcons.some(el => el.type === "a")) {
      rightSideIcons.push(
        <a onClick={() => setShowMenu(true)} style={{ color: dropdownTextColor }}>
          <Icon
            bold
            name="menu"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}
          />
        </a>
      );
      setRightSideIcons(rightSideIcons);
    }
  }

  const handleRightSideNavIconsWidth = () => {
    if (logoPosition === "centered" || hamburgerPosition === "rightAligned") {
      return {
        height: containerHeight,
        paddingLeft: logoPosition === "rightAligned" ? 0 : 30,
        maxWidth: logoPosition === "rightAligned" ? "65vw" : "40vw"
      };
    }
    return {
      height: containerHeight
    };
  };

  return (
    <React.Fragment>
      <nav class={styles.container} style={{ background: backgroundColor }}>
        <div style={{ marginLeft: "0.2rem" }}>
          {showMenuLink && hamburgerPosition === "leftAligned" && (
            <a onClick={() => setShowMenu(true)} style={{ color: dropdownTextColor }}>
              <Icon bold name="menu" />
            </a>
          )}
          <header style={{ height: containerHeight }} className={styles.header}>
            {logoPosition !== "rightAligned" && <img src={logoFile} className={logoPosition === "centered" ? styles.logoCentered : {}} />}
          </header>
        </div>
        {extraIconImg  && (<a href={extraIconDestinationUrl || null}><div className={styles.extraIconImg}><img src={extraIconImg}/></div></a>)}
        <ul style={handleRightSideNavIconsWidth()}>
          <div className={styles.logoAndHamburger}>{rightSideIcons}</div>
          {navStyle == "v1.5" ? <AccountServicesBtn img={btnBackgroundImageFile} /> : null}
          {homeFeaturedAdTiles || navStyle == "v1.5" ? <HomeFeaturedAdTiles tiles={homeFeaturedAdTiles} brand={brand} /> : null}
        </ul>
      </nav>
      {showMenu ? <Menu navControls={navControls} hide={() => setShowMenu(false)} /> : null}
    </React.Fragment>
  );
});

export default NavComponent;
